/** Attribute Constructor Factory
    @description See https://stackoverflow.com/a/502384/722785
    @param {Array<[string,any]>} params Constructor parameters and default values names ie: [['first','john'],['last','smith']]
    @returns {function(): Data} Data Constructor
*/
export const makeDataStruct = (params = []) => {
    /** Structure Constructor */
    const constructor = (...args) => {
        const attributes = {};
        for (let i = 0; i < params.length; i++) {
            attributes[params[i][0]] = args[i] !== undefined ? args[i] : params[i][1]; // fallback to default value
        }
        return attributes;
    };
    return constructor;
};
